export default "__VITE_ASSET__BZ354GiU__"